import React from 'react';
import { Link } from '@freenow/wave';
const COOKIE_LINK_PLACEHOLDER = '${cookieLink}';
export const CookieInformationText = ({ informationText, link }) => {
    return informationText
        .split(COOKIE_LINK_PLACEHOLDER)
        .reduce((acc, value, index) => {
        if (index !== 0) {
            return acc
                .concat([
                React.createElement(Link, { href: link.url, rel: "noopener", target: "_blank" }, link.text),
            ])
                .concat(value);
        }
        return acc.concat(value);
    }, [])
        .map((e, i) => React.createElement("span", { key: i }, e));
};
